import ApiCrud from "./api-crud";
import apiCaller from "./api-caller";

class EmpresaService extends ApiCrud {
  resource = "empresas";
  primaryKey = "idempresa";

  uploadLogo(idempresa, base64, format) {
    return apiCaller
      .post(`/empresas/${idempresa}/logo`, { base64, format })
      .then((response) => response.data);
  }

  getLogoUrl(idempresa, version) {
    const base = process.env.VUE_APP_API_URL;
    return `${base}/empresas/${idempresa}/logo?v=${version}`;
  }
}

export default new EmpresaService();
